/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandThirdPartyContentEnabled} from '../api'

export const useMutationSetBrandThirdPartyContentEnabled = createReactQueryMutationHook('setBrandThirdPartyContentEnabled', setBrandThirdPartyContentEnabled)
